import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
import ApplFeeStatusModalSF from './ApplFeeStatusModalSF.js'

const ApplicationFeeUI = ({ context, loan, transaction, onRefreshClick, applFeeStatusUpdated, onApplFeeStatusUpdateClick, onApplFeeStatusCancelClick }) =>
  <CardUI className='g_m_bottom_100' title='Loan application fee'>
    <div className='g_flex_h'>
      <span className='g_flex_v'>
        ₹11,800.00
        <span className='g_muted g_small'>₹10,000.00 + 18% GST</span>
      </span>
      <div className='g_flex_v'>
        <span className='g_flex_h g_flex_right'>
          <BadgeUI label={loan.applFeeStatus || 'unpaid'} />
          {
            loan.applFeeStatus !== 'paid' &&
            <span className='icon icon-pencil g_link_2 g_m_left_50' onClick={onApplFeeStatusUpdateClick} />
          }
        </span>
        <span className='g_flex_h g_flex_right g_muted'>{loan.applFeeStatusDateF}</span>
      </div>
    </div>
    {
      transaction &&
      <div className='g_m_top_100'>
        <span>{transaction.transactionDateF}</span>
        <span className='g_m_left_50 g_muted'>{transaction.transactionId}</span><br />
        <span className='g_small'>{transaction.narration}</span>
      </div>
    }

    <ApplFeeStatusModalSF context={context} loan={loan} onRefreshClick={onRefreshClick}
      onCancelClick={onApplFeeStatusCancelClick} updateMode={applFeeStatusUpdated} />

  </CardUI>

export default ApplicationFeeUI
